






import {Component, Vue} from "vue-property-decorator";
import ChatIcon from '../../assets/svg/chat.svg';

@Component({
    name: "ObjectSidebarShow",
    components: { ChatIcon }
})
export default class ObjectSidebarShow extends Vue {

}
